import { ChangeEvent } from "react";
import { FormControlLabel, Checkbox } from "@mui/material";
import * as S from "./styles";
import { colors } from "@/theme";

export type BorderedCheckboxProps = {
  checked: boolean;
  label?: string;
  labelPlacement?: "end" | "start" | "top" | "bottom";
  style?: object;
  onChange?: (checked: boolean) => void;
};

const BorderedCheckbox: React.FC<BorderedCheckboxProps> = ({
  checked = false,
  label = undefined,
  labelPlacement = undefined,
  style = undefined,
  onChange = undefined,
}) => {
  return (
    <S.BorderedCheckboxContainer style={style}>
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e: ChangeEvent<HTMLInputElement>) => {
              onChange?.(e.target.checked);
            }}
            sx={{
              color: colors.black,
              "&.Mui-checked": {
                color: colors.ozone,
              },
            }}
          />
        }
        label={label}
        labelPlacement={labelPlacement}
        sx={{
          "& .MuiFormControlLabel-label": {
            color: colors.black,
            "font-family": "PF DIN Text Pro",
            "font-size": "12px",
            "font-style": "normal",
            "font-weight": "400",
            "line-height": "16px",
          },
        }}
      />
    </S.BorderedCheckboxContainer>
  );
};

export default BorderedCheckbox;
